import { render, staticRenderFns } from "./ClinicAddEdit.vue?vue&type=template&id=69c2b649"
import script from "./ClinicAddEdit.vue?vue&type=script&lang=js"
export * from "./ClinicAddEdit.vue?vue&type=script&lang=js"
import style0 from "./ClinicAddEdit.vue?vue&type=style&index=0&id=69c2b649&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports